import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerDichiarazioniFiscaliModalComponent } from './worker-dichiarazioni-fiscali-modal';

export const WorkerDichiarazioniFiscaliModalModule: string = ng
    .module('worker-dichiarazioni-fiscali-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerDichiarazioniFiscaliModalComponent', WorkerDichiarazioniFiscaliModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-dichiarazioni-fiscali-modal/worker-dichiarazioni-fiscali-modal.module.ts